import React from "react";
import {
  CalendarDays,
  Settings2,
  BadgeCheck,
  Users,
} from "lucide-react";

const advantagesData = [
  {
    icon: <CalendarDays size={38} className="text-[#0f2454]" />,
    title: "Cost Savings",
    desc: `Based on internal client studies, employee enrollment in
    DailyPay provides an average 44.8% reduction in the
    turnover rate for clients in the QSR industry.`,
  },

  {
    icon: <Settings2 size={38} className="text-[#0f2454]" />,
    title: "Improved Productivity",
    desc: `68% of DailyPay users in restaurants or QSR industries
    say that DailyPay helps them be more diligent about
    their spending.`,
  },

  {
    icon: <BadgeCheck size={38} className="text-[#0f2454]" />,
    title: "Happier Customers",
    desc: `69% of DailyPay users in restaurants or QSR industries
    say that DailyPay makes it easier to save a portion
    of their income.`,
  },

  {
    icon: <Users size={38} className="text-[#0f2454]" />,
    title: "Be a Modern Employer",
    desc: `DailyPay is offered to over 500k franchise employees
    across more than 350+ franchise brands.`,
  },
];

const EMP_StickyScrollSection = () => {
  return (
    <section className="w-full bg-[#f5f5f5]">

      {/* MAIN WRAPPER */}
      <div
        className="
          max-w-[1800px]
          mx-auto
          grid
          grid-cols-1
          lg:grid-cols-2
          gap-12
          lg:gap-24
          px-4
          sm:px-6
          md:px-10
          lg:px-16
          py-12
          md:py-10
        "
      >

        {/* ================= LEFT FIXED CONTENT ================= */}
        <div
          className="
            lg:sticky
            lg:top-0
            h-fit
            lg:h-screen
            flex
            items-center
          "
        >

          <div className="max-w-[700px] lg:-mt-[300px] lg:ml-[60px]">

            {/* HEADING */}
            <h2
              className="
                text-[#220000]
                font-[900]
                lg:font-serif
                leading-[1.05]
                text-[36px]
                sm:text-[42px]
                md:text-[42px]
                lg:text-[42px]
                lg:max-w-[600px]
              "
            >
              Advantages of On-Demand Pay for Restaurants and QSRs
            </h2>

            {/* PARAGRAPH 1 */}
            <p
              className="
                mt-0
                text-black
                leading-relaxed
                text-[15px]
                sm:text-[18px]
                md:text-[20px]
                lg:text-[16px]
              "
            >
              According to DailyPay research, 68% of DailyPay users in
              restaurants or QSR industries say that DailyPay helps
              them be more diligent about their spending. DailyPay
              empowers employees to access their earned pay whenever
              they need it, so they can pay bills, grow their savings,
              and improve their overall financial wellness.
            </p>

            {/* PARAGRAPH 2 */}
            <p
              className="
                mt-8
                text-black
                leading-relaxed
                text-[15px]
                sm:text-[18px]
                md:text-[20px]
                lg:text-[16px]
              "
            >
              QSR companies that partner with an industry-leading
              on-demand pay solution like DailyPay experience reduced
              turnover costs, increased staff productivity, and
              improved customer service and satisfaction.
            </p>

            {/* FOOTNOTE */}
            <p
              className="
                mt-8
                text-[#8f8f8f]
                leading-relaxed
                text-[12px]
                sm:text-[14px]
                lg:text-[13px]
              "
            >
              Hanover Research Study: Companies with EWA Solutions,
              September 2023 <br />
              DailyPay Employee Experience Research, Arizent study
              commissioned by DailyPay, September 2023
            </p>

          </div>

        </div>

        {/* ================= RIGHT SCROLL CONTENT ================= */}
        <div className="relative mt-0 lg:-mt-[50px]">

  <div className="space-y-0">

    {advantagesData.map((item, index) => (
      <div
        key={index}
        className="
          flex
          items-center
          border-b
          border-[#d8d8d8]
          py-8
          sm:py-10
          lg:py-14
        "
      >

        <div
          className="
            max-w-[520px]
            mt-0
            lg:-mt-[30px]
          "
        >

          {/* ICON */}
          <div>
            {item.icon}
          </div>

          {/* TITLE */}
          <h3
            className="
              mt-4
              lg:mt-2
              text-black
              font-semibold
              leading-tight
              text-[22px]
              sm:text-[28px]
              md:text-[30px]
              lg:text-[24px]
              font-sans
            "
          >
            {item.title}
          </h3>

          {/* DESCRIPTION */}
          <p
            className="
              mt-4
              lg:mt-2
              text-black
              leading-relaxed
              text-[14px]
              sm:text-[18px]
              md:text-[20px]
              lg:text-[16px]
              font-[300]
            "
          >
            {item.desc}
          </p>

        </div>

      </div>
    ))}

  </div>



        </div>

      </div>

    </section>
  );
};

export default EMP_StickyScrollSection;